<template>
    <div>
        <v-dialog v-model="reviewexerciseformdialog" max-width="900px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="text-subtitle-1 mb-4">
                        {{ isEdit ? $t('pmreviewexercise.editreviewformselection') : $t('pmreviewexercise.reviewformselection') }}
                    </span>
                </v-card-title>
            <v-card-text>
              <v-container>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.appraisalgroup')"
                                type="text"
                                :items="valValueList"
                                hide-selected
                                v-model="formData.valvalueid"
                                @input="updateValue"
                                @change="changeValValueHandler(formData.valvalueid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.appraisalgroupcode')"
                                type="text"
                                v-model="formData.valvaluecode"
                                dense
                                background-color="#ffeab2"
                                readonly
                                @input="updateValue"
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmreviewexercise.reviewform')"
                                type="text"
                                :rules="[rules.required]"
                                :items="reviewFormList"
                                hide-selected
                                v-model="formData.pmreviewformid"
                                @input="updateValue"
                                @change="changeReviewFormHandler(formData.pmreviewformid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                 :label="$t('pmreviewexercise.reviewformcode')"
                                type="text"
                                v-model="formData.pmreviewformcode"
                                background-color="#ffeab2"
                                readonly
                                @input="updateValue"
                                dense
                                class="v-input"
                            ></v-text-field>
                        </v-col>
                    </v-row>
            </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveReviewExerciseForm">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeReviewExerciseForm">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="copyDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-subtitle-1 mb-4">{{$t('pmreviewexercise.copyfromexercise')}}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" class="pb-n4 mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="$t('pmreviewexercise.sourceexercise')"
                                    type="text"
                                    :items="sourceExerciseList"
                                    hide-selected
                                    v-model="copyFormData.sourceexerciseid"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="pb-n4">
                                <v-radio-group v-model="copyFormData.mode" dense hide-details>
                                    <v-radio :label="$t('pmreviewexercise.copymodeskip')" value="skip"></v-radio>
                                    <v-radio :label="$t('pmreviewexercise.copymodereplace')" value="replace"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row v-if="copyFormData.mode === 'replace'">
                            <v-col cols="12" class="pb-n4">
                                <span style="color: #b71c1c; font-size: 0.85rem;">{{$t('pmreviewexercise.copymodereplacewarning')}}</span>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isCopyErr" class="mt-n8">
                    <span style="font-weight: bold; color: red">{{copyErrMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text :disabled="!copyFormData.sourceexerciseid" @click="confirmCopy">{{$t('button.save')}}</v-btn>
                    <v-btn color="red darken-1" text @click="closeCopyDialog">{{$t('button.cancel')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-row class="mt-4 mb-2">
            <v-col cols="12" class="review-stats-label" style="display:flex;align-items:center;padding-top:8px;padding-bottom:8px;">
                {{$t('pmreviewexercise.reviewformtemplates')}}
                <v-spacer></v-spacer>
                <div class="export-icon-btns">
                    <button type="button" class="export-icon-btn export-icon-copy" @click="openCopyDialog" :title="$t('pmreviewexercise.copyfromexercise')">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                        {{$t('pmreviewexercise.copyfromexercise')}}
                    </button>
                </div>
            </v-col>
        </v-row>

        <div style="overflow-x: auto; width: 100%;">
        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
:sort-by="['code']"
            style="width:100%"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>

            <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
            </div>

        </v-data-table>
        </div>

        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="confirmActionHandler"
                v-on:cancelConfirm="isConfirm = false"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            reviewexerciseformdialog: false,
            detailItem: this.parentObject.detailItem,

            formData: {
                pmreviewexerciseid : this.parentObject.pmreviewexerciseid,
                valvalueid : null,
                valvaluecode : null,
                pmreviewformid : null,
                pmreviewformcode : null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            valValue: [],
            valValueList: [],
            reviewForm: [],
            reviewFormList: [],

            isEdit: false,

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',

            // Overlay confirm dialog (used for delete + copy-replace warnings)
            isConfirm: false,
            messageConfirm: '',
            confirmAction: null,
            pendingDeleteItem: null,

            // Copy from another Review Exercise
            copyDialog: false,
            sourceExercise: [],
            sourceExerciseList: [],
            copyFormData: {
                sourceexerciseid: null,
                pmreviewexerciseid: this.parentObject.pmreviewexerciseid,
                mode: 'skip',
                userid: this.$store.getters.userId,
            },
            isCopyErr: false,
            copyErrMsg: '',
        }
    },

    methods: {
        newItem() {
            this.isExisting = false;
            this.modify = false;
            this.resetSelections();
        },
        loadValValue() {
            const vm = this;
            this.$store.dispatch('get', {url: "/groupp_grouppb_appraisal/all"})
            .then(function (res) {
                vm.valValue = res.data.rec;

                for (let i = 0; i < vm.valValue.length; i++) {
                    vm.valValueList.push({
                    text: vm.valValue[i].valuecode,
                    value: vm.valValue[i].valvalueid,
                    });
                }
                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        changeValValueHandler(id) {
            let item = this.valValue.find(item => item.valvalueid == id);
            this.formData.valvaluecode = item.valuecode;
        },

        loadReviewForm() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewform/active/all"})
            .then(function (res) {
                vm.reviewForm = res.data.rec;

                for (let i = 0; i < vm.reviewForm.length; i++) {
                    vm.reviewFormList.push({
                    text: vm.reviewForm[i].formcode,
                    value: vm.reviewForm[i].id,
                    });
                }

                })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        changeReviewFormHandler(id) {
            let item = this.reviewForm.find(item => item.id == id);
            this.formData.pmreviewformcode = item.formcode;
        },

        modifyItemHandler(item) {
            this.isEdit = true;
            this.reviewexerciseformdialog = true;
            this.formData = {...this.formData, ...item};
        },

        deleteItemHandler(item) {
            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            this.pendingDeleteItem = item;
            this.messageConfirm = this.$t('pmreviewexercise.deletereviewformtemplate');
            this.confirmAction = 'delete';
            this.isConfirm = true;
        },

        performDelete(item) {
            const vm = this;

            this.$store.dispatch('delete', {url: "/reviewexerciseform/" + item.id})
            .then(function () {
                const index = vm.detailItem.findIndex(detail => detail.id === item.id);
                if (index !== -1) {
                    vm.detailItem.splice(index, 1);
                }
            })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        // Fired by app-confirm's @confirm event once the user clicks OK on the overlay
        confirmActionHandler() {
            this.isConfirm = false;

            if (this.confirmAction === 'delete' && this.pendingDeleteItem) {
                this.performDelete(this.pendingDeleteItem);
            } else if (this.confirmAction === 'copy-replace') {
                this.performCopy();
            }

            this.confirmAction = null;
            this.pendingDeleteItem = null;
        },

        saveReviewExerciseForm() {
            const vm = this;

            if (this.isEdit) {//Edit
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                this.$store.dispatch('put', {url: "/reviewexerciseform/" + this.formData.id, payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.detailItem.splice(index, 1, { ...this.formData });
                        }
                        this.reviewexerciseformdialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            } else { //Add
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                this.$store.dispatch('post', {url: "/reviewexerciseform/create", payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        this.detailItem.push(res.data.result);
                        this.reviewexerciseformdialog = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            }
        },

        closeReviewExerciseForm() {
            this.reviewexerciseformdialog = false;
            this.isErr = false;
            this.isEdit = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                pmreviewexerciseid : this.parentObject.pmreviewexerciseid,
                valvalueid : null,
                valvaluecode : null,
                pmreviewformid : null,
                pmreviewformcode : null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },

        updateValue() {
            this.$emit('input', {
                reviewcode: this.formData.reviewcode,
                valvalueid : this.formData.valvalueid,
                valvaluecode : this.formData.valvaluecode,
                pmreviewformid : this.formData.pmreviewformid,
                pmreviewformcode : this.formData.pmreviewformcode,
            });
        },

        loadSourceExercise() {
            const vm = this;
            this.$store.dispatch('get', {url: "/reviewexercise/all"})
            .then(function (res) {
                vm.sourceExercise = res.data.rec;
                vm.sourceExerciseList = vm.sourceExercise
                    .filter(item => item.id != vm.parentObject.pmreviewexerciseid)
                    .map(item => ({
                        text: item.reviewcode,
                        value: item.id,
                    }));
            })
            .catch(function (err) {
                vm.errMsg = err;
            });
        },

        openCopyDialog() {
            if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                return false;
            }
            this.resetCopySelections();
            this.copyDialog = true;
        },

        closeCopyDialog() {
            this.copyDialog = false;
            this.isCopyErr = false;
            this.resetCopySelections();
        },

        resetCopySelections() {
            this.copyFormData = {
                sourceexerciseid: null,
                pmreviewexerciseid: this.parentObject.pmreviewexerciseid,
                mode: 'skip',
                userid: this.$store.getters.userId,
            };
        },

        confirmCopy() {
            if (!this.copyFormData.sourceexerciseid) {
                return false;
            }

            if (this.copyFormData.mode === 'replace') {
                this.messageConfirm = this.$t('pmreviewexercise.copymodereplaceconfirm');
                this.confirmAction = 'copy-replace';
                this.isConfirm = true;
                return;
            }

            this.performCopy();
        },

        performCopy() {
            const vm = this;

            this.$store.dispatch('post', {url: "/reviewexerciseform/copy", payload: this.copyFormData})
            .then((res) => {
                if (res.data.error) {
                    vm.isCopyErr = true;
                    vm.copyErrMsg = res.data.error;
                } else {
                    vm.detailItem.splice(0, vm.detailItem.length, ...res.data.rec);
                    vm.copyDialog = false;
                    vm.isCopyErr = false;
                    vm.resetCopySelections();
                }
            })
            .catch((err) => {
                vm.isCopyErr = true;
                vm.copyErrMsg = err;
                console.log("err", err);
            });
        },
    },

    mounted() {
        this.loadValValue();
        this.loadReviewForm();
        this.loadSourceExercise();
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}

/* Export/action buttons — same convention as compensationanalysis, headcountanalysis/Detail.vue
   and claimutilizationtrendanalysis/Form_Detail.vue */
.export-icon-btns { display: flex; gap: 8px; align-items: center; }
.export-icon-btn {
  -webkit-appearance: none; -moz-appearance: none; appearance: none;
  display: inline-flex; align-items: center; gap: 6px;
  box-sizing: border-box; height: 32px; line-height: 1;
  padding: 0 14px; border-radius: 8px;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit;
}
.export-icon-btn svg { display: block; flex-shrink: 0; }
.export-icon-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.export-icon-copy { background: #EFF6FF !important; color: #2563EB !important; border: 1px solid #BFDBFE !important; }
.export-icon-copy:hover:not(:disabled) { background: #2563EB !important; color: #fff !important; border-color: #2563EB !important; }
</style>
